<div class="dialog-content">
    <h2 mat-dialog-title>{{dialogData.title}}</h2>
    <mat-dialog-content>
    <p>{{dialogData.message}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="buttons">
        <button mat-button (click)="onCancel()" class="cancel-btn">{{ dialogData.cancelButtonText }}</button>
        <button mat-button cdkFocusInitial [mat-dialog-close]="dialogData.confirmClicked" class="confirm-btn">
            {{ dialogData.confirmButtonText}}</button>
    </mat-dialog-actions>
</div>